import { render } from "./billingDatas.vue?vue&type=template&id=e06f95f2"
import script from "./billingDatas.vue?vue&type=script&lang=js"
export * from "./billingDatas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__